import styled from 'styled-components'

export const BlogReadMoreContainer = styled.div`
  margin-top: 108px;

  @media (max-width: 1150px) {
    margin-top: 40px;
  }
`

export const BlogReadMoreHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;

  @media (max-width: 1150px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`

export const BlogReadMoreTitle = styled.span`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: block;

  @media (max-width: 1150px) {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }
`

export const BlogReadMoreLink = styled.a`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  cursor: pointer;

  @media (max-width: 1150px) {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }
`

export const BlogReadMorePosts = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
`
